import { createContext } from 'preact'
import { ariaLiveLevels } from 'ui/utils/seamly-utils'

type SeamlyLiveRegionContextValue = (_args: {
  ariaLive: keyof typeof ariaLiveLevels
  messageText: string
}) => void

export const SeamlyLiveRegionContext =
  createContext<SeamlyLiveRegionContextValue | null>(null)
